// extracted by mini-css-extract-plugin
export var addToCartButton = "_uc-b";
export var arrowButtonContainer = "_uc-9";
export var arrowButtonIcon = "_uc-a";
export var carouselArrowButton = "_uc-6";
export var carouselElementContainer = "_uc-1";
export var left = "_uc-7";
export var productDisplayCarouselContainer = "_uc-0";
export var productTileContainer = "_uc-2";
export var productTileImage = "_uc-4";
export var productTileImageContainer = "_uc-3";
export var productTileTitle = "_uc-5";
export var right = "_uc-8";
export var sliderOverflow = "_uc-c";